'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _taggedTemplateLiteralLoose = require('@babel/runtime/helpers/taggedTemplateLiteralLoose');
var React = require('react');
var bumbag = require('bumbag');
var faSpinnerThird = require('@fortawesome/pro-regular-svg-icons/faSpinnerThird');
var reactFontawesome = require('@fortawesome/react-fontawesome');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _taggedTemplateLiteralLoose__default = /*#__PURE__*/_interopDefaultLegacy(_taggedTemplateLiteralLoose);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _templateObject;
var LoadingWrapper = bumbag.styled(bumbag.Box)(_templateObject || (_templateObject = _taggedTemplateLiteralLoose__default["default"](["\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])));

var LoadingPage = function LoadingPage(_ref) {
  var title = _ref.title;
  return /*#__PURE__*/React__default["default"].createElement(LoadingWrapper, {
    className: "content has-text-centered"
  }, /*#__PURE__*/React__default["default"].createElement(bumbag.Box, {
    className: "content-body",
    padding: "major-4"
  }, /*#__PURE__*/React__default["default"].createElement(reactFontawesome.FontAwesomeIcon, {
    icon: faSpinnerThird.faSpinnerThird,
    size: "2x",
    className: "text-primary-base animate-spin"
  }), /*#__PURE__*/React__default["default"].createElement("h2", {
    className: "mb-5 mt-4 text-xl font-bold"
  }, "Loading", title ? " " + title : '', "...")));
};

LoadingPage.defaultProps = {
  title: null
};

exports["default"] = LoadingPage;
